import { render, staticRenderFns } from "./ReleaseAge.vue?vue&type=template&id=10125067&scoped=true"
import script from "./ReleaseAge.vue?vue&type=script&lang=js"
export * from "./ReleaseAge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10125067",
  null
  
)

export default component.exports